import { render, staticRenderFns } from "./CostsGroupUnit.vue?vue&type=template&id=1bd7e63c&"
import script from "./CostsGroupUnit.vue?vue&type=script&lang=js&"
export * from "./CostsGroupUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports